import { cloneDeep } from "lodash";
import PubSub from "pubsub-js";

import PubSubTopics from "../constants/pubSubTopics";
import { messageTypes as nativeCommsBroadcastMessageTypes } from "./nativeCommsBroadcaster";

/* eslint-disable no-console */

export default () => {
  const browserConsoleLog = console.log;
  const browserConsoleDir = console.dir;

  console.log = logMessage => {
    browserConsoleLog(logMessage);
    let data = {
      msg: nativeCommsBroadcastMessageTypes.CONSOLE_LOG,
      log: `${logMessage}`
    };
    PubSub.publish(PubSubTopics.sendNativeMessage, data);
  };

  console.dir = logObject => {
    let str = JSON.stringify(logObject);
    if (!str) {
      str = "<could not stringify object>";
    }
    browserConsoleDir(logObject);
    let data = {
      msg: nativeCommsBroadcastMessageTypes.CONSOLE_LOG,
      log: str
    };
    PubSub.publish(PubSubTopics.sendNativeMessage, data);
  };

  console.dirJs = logObject => {
    console.dir(logObject && logObject.toJS ? logObject.toJS() : cloneDeep(logObject));
  };

  // window.addEventListener('error', event => {
  //   let str = `Javascript Error: ${event.message} (${event.filename} Line ${event.lineno} Col ${event.colno})`;
  //   let data = {
  //     msg: nativeCommsBroadcastMessageTypes.CONSOLE_LOG,
  //     log: str
  //   };
  //   PubSub.publish(PubSubTopics.sendNativeMessage, data);
  // });
};
